export default {
  API_ENDPOINT: 'https://intense-hamlet-52340.herokuapp.com/api',
  // API_ENDPOINT: 'http://localhost:8000/api',

  TOKEN_KEY: 'homi-client-auth-token',
}
